// src/pages/ZNotFound.jsx
import React        from "react";
import { useNavigate }      from "react-router-dom";
import { useTranslation }   from "react-i18next";

const ZNotFound = () => {
  const { t }    = useTranslation();
  const navigate = useNavigate();

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      gap: 16,
      backgroundColor: "#0d0a05",
      color: "#e8d5b0",
    }}>
      <span style={{
        fontFamily: "'Playfair Display', serif",
        fontSize: 72,
        fontWeight: 900,
        fontStyle: "italic",
        color: "rgba(212,168,83,0.2)",
      }}>404</span>

      <p style={{
        fontFamily: "'Courier Prime', monospace",
        fontSize: 11,
        letterSpacing: "0.28em",
        color: "var(--bone-text-muted)",
        textTransform: "uppercase",
      }}>
        {t('notFound.subtitle')}
      </p>

      <button
        onClick={() => navigate("/")}
        style={{
          fontFamily: "'Courier Prime', monospace",
          fontSize: 10,
          letterSpacing: "0.22em",
          color: "var(--bone-text-accent)",
          textTransform: "uppercase",
          textDecoration: "none",
          marginTop: 8,
          border: "1px solid rgba(212,168,83,0.2)",
          padding: "8px 20px",
          background: "transparent",
          cursor: "pointer",
          transition: "all 0.2s",
        }}
        onMouseEnter={e => {
          e.currentTarget.style.borderColor = "rgba(212,168,83,0.5)";
          e.currentTarget.style.color = "var(--bone-text-primary)";
        }}
        onMouseLeave={e => {
          e.currentTarget.style.borderColor = "rgba(212,168,83,0.2)";
          e.currentTarget.style.color = "var(--bone-text-accent)";
        }}
      >
        {t('notFound.backHome')}
      </button>
    </div>
  );
};

export default ZNotFound;
